import { graphql } from 'react-relay';

export const aiCustomAppsQuery = graphql`
    query aiCustomAppsQuery($scope: String!) {
        aiCustomApps(scope: $scope) {
            aiCustomAppID
            name
            description
            mediaFactoryAppID
            isActive
        }
    }
`;

export const createAICustomAppMutation = graphql`
    mutation aiCustomAppsCreateMutation($input: CreateAICustomAppInput!) {
        createAICustomApp(input: $input) {
            aiCustomAppID
            name
            description
            mediaFactoryAppID
            isActive
        }
    }
`;

export const updateAICustomAppMutation = graphql`
    mutation aiCustomAppsUpdateMutation($input: UpdateAICustomAppInput!) {
        updateAICustomApp(input: $input) {
            aiCustomAppID
            name
            description
            mediaFactoryAppID
            isActive
        }
    }
`;

export const renameAICustomAppMutation = graphql`
    mutation aiCustomAppsRenameMutation($input: RenameAICustomAppInput!) {
        renameAICustomApp(input: $input) {
            aiCustomAppID
            name
            description
            mediaFactoryAppID
            isActive
        }
    }
`;

export const deleteAICustomAppMutation = graphql`
    mutation aiCustomAppsDeleteMutation($aiCustomAppID: Long!) {
        deleteAICustomApp(aiCustomAppID: $aiCustomAppID)
    }
`;

export const createMediaFactoryEmbedMutation = graphql`
    mutation aiCustomAppsCreateMediaFactoryEmbedMutation($input: CreateMediaFactoryEmbedInput!) {
        createMediaFactoryEmbed(input: $input) {
            token
            jti
            expiresAt
            frontendUrl
            sdkUrl
            workflowExternalId
        }
    }
`;

export const createMediaFactoryEditorEmbedMutation = graphql`
    mutation aiCustomAppsCreateMediaFactoryEditorEmbedMutation($input: CreateMediaFactoryEditorEmbedInput!) {
        createMediaFactoryEditorEmbed(input: $input) {
            token
            jti
            expiresAt
            editorUrl
            sdkUrl
            workflowExternalId
        }
    }
`;
